/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, typography } from '@coursera/cds-core';

import useIsLohp from 'bundles/collections-common/utils/useIsLohp';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  subtitle: css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

type Props = {
  sectionTitle?: string | null;
  title?: string | null;
  subtitle?: string | null;
  url?: string | null;
  trackingKey: string | null;
};

const CollectionHeader: React.FC<Props> = ({ sectionTitle, title, subtitle, url, trackingKey }) => {
  const isLohp = useIsLohp();

  const renderedTitle =
    url && !isLohp ? (
      <Link
        component={TrackedLink2}
        href={url}
        trackingName={`${trackingKey}_cta`}
        iconPosition="after"
        variant="quiet"
        css={typography.d2}
      >
        {title}
      </Link>
    ) : (
      <Typography variant="d2" component="h2" css={styles.title}>
        {title}
      </Typography>
    );

  return (
    <div>
      {sectionTitle && (
        <Typography variant="h2semibold" component="div" color="body" css={styles.title}>
          {sectionTitle}
        </Typography>
      )}
      {title && renderedTitle}
      {subtitle && (
        <Typography variant="h2" component="p" css={styles.subtitle}>
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default CollectionHeader;
